import { AppLayout } from '@components/AppLayout'
import { TotalIncomePanel } from '@components/panels/TotalIncomePanel'
import { SummaryCorePlanIncome } from '@pages/summary/SummaryCorePlanIncome'
import { SummaryCorePlusIncome } from '@pages/summary/SummaryCorePlusIncome'
import { SummaryCorePlusIncome2024 } from '@pages/v2024/summary/SummaryCorePlusIncome'
import { RequireAuth } from '@providers/AuthProvider'
import { TrackerEvent, measureTimeSpent, useTracker } from '@providers/TrackerProvider'
import { store } from '@stores/Store'
import { observer } from 'mobx-react'
import React, { FunctionComponent, useEffect } from 'react'
import styles from './SummaryPage.module.scss'

export const SummaryPage: FunctionComponent = observer(() => {
  const { versionHelper } = store
  const { version2024 } = versionHelper

  const { track } = useTracker()
  useEffect(() => {
    track(TrackerEvent.HPUB_PAGE_VIEW, { page_title: 'Total Income' })
    return measureTimeSpent((timeSpent) => { track(TrackerEvent.HPUB_SCREEN_TIME, { page_title: 'Total Income', time_spent: timeSpent }) })
  }, [])

  return (
    <RequireAuth>
      <AppLayout className={styles.content} title="TITLE" navigationButton='back' stickyHeader>
        <SummaryCorePlanIncome />
        {version2024 ? <SummaryCorePlusIncome2024 /> : <SummaryCorePlusIncome />}
        <TotalIncomePanel navigationButton={'back'} />
      </AppLayout>
    </RequireAuth>
  )
})
